/* tslint:disable */
/* eslint-disable */
export enum FundingInstructionsOrderBy {
  Ref = 'Ref',
  MID = 'MID',
  DateCreated = 'DateCreated',
  FundingStatus = 'FundingStatus',
  DateFunded = 'DateFunded'
}
